<template>
  <div class="main-product-item" @mouseenter="onMouseEnter()" @mouseleave="onMouseLeave()" @click="itemClick()">
    <img class="item-bg" :src="require(`@/assets/images/${mainProductItem.bgImg}`)" />
    <div class="item-fg" :class="{'item-bg-trans':!mouseOnItem}"  v-text="mainProductItem.itemDesc"/>
    <div class="item-name" v-text="mainProductItem.itemName"></div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "MainProductItem",
  props:{
    mainProductItem:{
      bgImg:"",
      itemName:"",
      itemDesc:"",
      path:"",
    }
  },
  setup(props) {
    let mouseOnItem = ref(false);

    function onMouseEnter() {
      mouseOnItem.value = true;
    }

    function onMouseLeave() {
      mouseOnItem.value = false;
    }

    const router = useRouter()
    function itemClick(){
      router.push({path:props.mainProductItem.path})
    }

    return {
      onMouseEnter,
      onMouseLeave,
      mouseOnItem,
      itemClick,
    };
  }
};
</script>

<style scoped>
.main-product-item {
  width: 280px;
  height: 400px;
  position: relative;
  cursor: pointer;
}

.item-bg {
  /*background-image: url("./../assets/images/main-product-bg0.png");*/
  width: 100%;
  height: 100%;
  background-size: cover;
  position: absolute;
  transition: all 0.4;
}

.item-bg-trans {
  /*transform: translateY(100%);*/
  top: 100%;
  display: none;
}

.item-name {
  position: absolute;
  bottom: 0;
  width: 100%;
  line-height: 60px;
  text-align: center;
  font-size: 22px;
  color: white;
  background-color: #00A0E9;
}

.item-fg {
  background-color: rgba(0, 160, 233, 0.72);
  position: absolute;
  width: 100%;
  height: 100%;
  padding-top: 58px;
  font-size: 16px;
  color: white;
  line-height: 30px;
  padding-left: 22px;
  padding-right: 27px;
}
</style>
